import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/theme-monokai';
import { PencilIcon, TrashIcon, PlusIcon } from '@heroicons/react/24/outline';

const AdminDashboard = () => {
  const [templates, setTemplates] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    code: '',
    image: null
  });
  const [editingTemplate, setEditingTemplate] = useState(null);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await axios.get('http://localhost:5000/api/templates');
        setTemplates(response.data);
      } catch (error) {
        console.error('Error fetching templates:', error);
      }
    };
    fetchTemplates();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formPayload = new FormData();
    formPayload.append('name', formData.name);
    formPayload.append('category', formData.category);
    formPayload.append('code', formData.code);
    formPayload.append('image', formData.image);

    try {
      if (editingTemplate) {
        await axios.put(`http://localhost:5000/api/templates/${editingTemplate._id}`, formPayload, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
      } else {
        await axios.post('http://localhost:5000/api/templates', formPayload, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
      }
      setEditingTemplate(null);
      setFormData({ name: '', category: '', code: '', image: null });
      const response = await axios.get('http://localhost:5000/api/templates');
      setTemplates(response.data);
    } catch (error) {
      console.error('Error creating/updating template:', error);
    }
  };

  const handleEdit = (template) => {
    setEditingTemplate(template);
    setFormData({
      name: template.name,
      category: template.category,
      code: template.code,
      image: null
    });
  };

  const handleDelete = async (templateId) => {
    try {
      await axios.delete(`http://localhost:5000/api/templates/${templateId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      const response = await axios.get('http://localhost:5000/api/templates');
      setTemplates(response.data);
    } catch (error) {
      console.error('Error deleting template:', error);
    }
  };

  return (
    <div className="min-h-screen bg-stone-100 p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-800 mb-8">Admin Dashboard</h1>
        
        <form onSubmit={handleSubmit} className="mb-8 space-y-4 bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">{editingTemplate ? 'Edit Template' : 'Upload Template'}</h2>
          <input
            type="text"
            placeholder="Template Name"
            className="w-full p-3 bg-stone-200 text-gray-800 rounded-lg"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          
          <input
            type="text"
            placeholder="Category"
            className="w-full p-3 bg-stone-200 text-gray-800 rounded-lg"
            value={formData.category}
            onChange={(e) => setFormData({ ...formData, category: e.target.value })}
          />
          
          <input
            type="file"
            accept="image/*"
            className="w-full p-3 bg-stone-200 text-gray-800 rounded-lg"
            onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })}
          />

          <AceEditor
            mode="html"
            theme="monokai"
            value={formData.code}
            onChange={(code) => setFormData({ ...formData, code })}
            className="w-full h-64 rounded-lg"
          />

          <button
            type="submit"
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 flex items-center"
          >
            <PlusIcon className="w-5 h-5 mr-2" />
            {editingTemplate ? 'Update Template' : 'Upload Template'}
          </button>
        </form>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {templates.map((template) => (
            <div key={template._id} className="bg-white rounded-xl p-4 shadow-lg">
              <img src={`http://localhost:5000${template.imageUrl}`} className="w-full h-40 object-cover mb-4 rounded-lg"/>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">{template.name}</h3>
              <p className="text-gray-600 mb-4">{template.category}</p>
              <div className="flex justify-between">
                <button
                  className="text-blue-600 hover:text-blue-500 flex items-center"
                  onClick={() => handleEdit(template)}
                >
                  <PencilIcon className="w-5 h-5 mr-1" />
                  Edit
                </button>
                <button
                  className="text-red-600 hover:text-red-500 flex items-center"
                  onClick={() => handleDelete(template._id)}
                >
                  <TrashIcon className="w-5 h-5 mr-1" />
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;